import React from 'react';

import Modal from 'react-bootstrap/Modal';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import ConfirmButton from '../../components/Buttons/ConfirmButton';

import classes from './styles.module.scss';
import useCheckMobileScreen from '../../hooks/useCheckMobileScreen';
import closeIcon from '../../assets/images/closeIconBlack.svg';

function clampFontSizeWithRegex(html) {
  return html.replace(/font-size\s*:\s*(\d+)px/gi, (fullMatch, pxValue) => {
    const size = parseInt(pxValue, 10);
    return size > 36 ? 'font-size:36px' : `font-size:${size}px`;
  });
}

export default function ViewerNotesModal({ show, handleClose, notes, resume }) {
  const isMobile = useCheckMobileScreen();

  const closeModalAndResumePlayback = () => {
    handleClose();
    resume();
  };

  return (
    <Modal
      show={show}
      centered
      contentClassName={classes.ViewerNotesModal}
      dialogClassName={classes.dialog}
      backdropClassName={classes.backdrop}
    >
      {isMobile && (
        <button
          type="button"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <img src={closeIcon} alt="close" />
        </button>
      )}
      <div className={classes.notesContainer}>
        <div
          className={classes.notes}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: isMobile ? clampFontSizeWithRegex(notes) : notes,
          }}
        />
      </div>
      <footer className={classes.footer}>
        <div className={classes.buttons}>
          <ConfirmButton
            width={isMobile ? 60 : undefined}
            onClick={closeModalAndResumePlayback}
          />
        </div>
      </footer>
    </Modal>
  );
}
